import React, { useState } from 'react';
import { Dropdown, Row, Button } from 'react-bootstrap';
import Form from './Form';
import { searchWord, validateCollections } from '../../helpers/common';

const Filter = ({ className, children, drop, ...rest }) =>
	<Dropdown className={`filter-container ${className}`} drop={drop ? drop : "right"} {...rest}>
		{children}
	</Dropdown>;

const FilterToggle = props =>
	<Dropdown.Toggle size="md" className="btn-filter" {...props}>
		<i className={props.iconClassName || "fa fa-filter"} aria-hidden="true"></i>
		{props.children}
	</Dropdown.Toggle>

export const FilterBox = props =>
	<Dropdown.Menu className="filter-box filter-transition">
		{props.children}
	</Dropdown.Menu>

const FilterBoxHeader = props => <Row>{props.children}</Row>;

const FilterBoxBody = props => <Row className="filter-box-body">{props.children}</Row>;

const FilterBoxFooter = props => <Row className="filter-footer">{props.children}</Row>;

const FilterApplyButton = props =>
	<Button variant="success" size="sm" disabled={props.disabled} className="px-3 mb-1" onClick={props.onClick}>Apply</Button>;

const FilterClearButton = props =>
	<Button variant="danger" size="sm" className="px-3 mb-1 mr-2" onClick={props.onClick}>Clear</Button>;

const FilterResetButton = props =>
	<Button variant="danger" size="sm" disabled={props.disabled} className="px-3 mb-1 mr-2" onClick={props.onClick}>Reset</Button>;

export const FilterOptions = props => {
	const [searchText, setSearchText] = useState('');
	const { selected, onSelect, keyname: { value, label }, selectAll, onSelectAll, totalLength } = props;
	let { options } = props;

	if (searchText.trim().length > 0) {
		options = validateCollections(options) && options.filter(e => searchWord(e[label], searchText));
	}

	return <div className="filter-options">
		<Form.Control variant="input" className="search-input py-2 mb-2" autoFocus value={searchText}
			autoComplete="off" placeholder="Search" onChange={e => setSearchText(e.target.value)} />

		<div className="option-list">
			{selectAll && totalLength > 0 && <div className="option-item">
				<input type="checkbox"
					className={"item-checkbox"}
					checked={totalLength === selected.length}
					onChange={e => onSelectAll(e)}
				/>
				<label >Select All</label>
			</div>}
			{options && options.map((item, i) =>
				<div className="option-item" key={i}>
					<input type="checkbox" className="item-checkbox" id={item[value]}
						checked={validateCollections(selected) && selected.indexOf(item[value]) >= 0}
						onChange={(e) => onSelect(item, e)}
					/>
					<label htmlFor={item[value]}>{item[label]}</label>
				</div>)}
		</div>
	</div >;
};

Filter.Toggle = FilterToggle;
Filter.Box = FilterBox;
FilterBox.Header = FilterBoxHeader;
FilterBox.Body = FilterBoxBody;
FilterBox.Footer = FilterBoxFooter;
Filter.ApplyButton = FilterApplyButton;
Filter.ClearButton = FilterClearButton;
Filter.Options = FilterOptions;
Filter.ResetButton = FilterResetButton;

export default Filter;